const info = [
  {
    title: 'Music for Film',
    link: 'https://www.taxi.com/members/michael-sayer',
    text1: 'A proud Taxi member for years. I love the process and the challenge of writing music for film.',
    text2: 'My music has been featured in indie films and podcasts and I\'m always looking for new projects.'
  },
  {
    title: 'Ghost of Young Michael',
    link: 'https://youngmichael.bandcamp.com',
    text1: 'Ghost of Young Michael is an ambient solo project. Using acoustic instruments and electric processing.',
    text2: 'I\'m exploring the relationship between the natural and the artificial.'
  },
  {
    title: 'Great Turtle',
    link: 'https://greatturtle.bandcamp.com',
    text1: 'The Great Turtle is an electro-acoustic duo formed with Casey Dorcey. Sound exploration and organic development are at the heart of the music.',
    text2: 'Blending native/folk like melodies with huge atmospheric world drones, The Great Turtle seeks to take their listeners on the ecstatic journey.',
  },
  {
    title: 'Crime Tiger',
    link: 'https://crimetiger.bandcamp.com',
    text1: 'Crime Tiger is a rock \'n roll band. We are currently recording our first album. We are looking forward to sharing it with you soon.',
    text2: '',
  }
];

const links = [
  {
    link: 'https://www.linkedin.com/in/mikesayer/',
    logo: '/linkedin.svg',
    alt: 'linkedin',
  },
  {
    link: 'https://www.twitter.com/michaeljsayer/',
    logo: '/twitter.svg',
    alt: 'twitter',
  },
  {
    link: 'https://www.michaelsayer.com/',
    logo: '/code-solid.svg',
    alt: 'software engineering cv',
  },
];

export { info, links };